<template>
  <div class="paypasswordcontent">
    <titlebar titleName="支付密码" goback="true"></titlebar>
    <div class="content">
      <ul>
        <li>
          <input type="text" placeholder="手机号码" />
        </li>
        <li>
          <input type="text" placeholder="原始密码" />
        </li>
        <li>
          <input type="text" placeholder="新密码" />
        </li>
        <li>
          <input type="text" placeholder="确认密码" />
        </li>
        <li>
          <input type="text" placeholder="验证码" />
          <p>获取验证码</p>
        </li>
      </ul>
      <div class="btn">确定</div>
    </div>
  </div>
</template>

<script>
import titlebar from "../../components/index/titleBar.vue";
export default {
  components: {
    titlebar,
  },
};
</script>

<style lang="less"  scoped>
.content {
  padding-top: 13vw;
  ul {
    width: 92vw;
    background: #fff;
    margin: 5vw auto;
    border-radius: 3vw;
    padding: 0 2.9333vw;
    li {
      width: 82vw;
      height: 12vw;
      display: flex;
      align-items: center;
      border-bottom: 0.3vw solid #ECECEC;
      input{
          width: 60vw;
          color: #bebebe;
      }
      p{
          color: #FFA623;
      }
      input::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #bebebe;
        /* placeholder字体大小  */
        font-size: 4vw;
        /* placeholder位置  */
        text-align: left;
        
      }
    }
    :last-child{
        border-bottom: none;
    }
  }
  .btn{
      width: 92vw;
      height: 12.2667vw;
      line-height: 12.2667vw;
      background: #FFA623;
      color: #fff;
      font-size: 4vw;
      margin: 0 auto;
      border-radius: 3vw;
  }
}
</style>